module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"heading":"Du hast Fragen? Wir haben die Antworten!","readAll":"Alle FAQs lesen","showMore":"Mehr anzeigen","showLess":"Weniger anzeigen"},"en":{"heading":"Don’t save your questions. We’ve got answers.","readAll":"Read all FAQs","showMore":"Show more","showLess":"Show less"}}')
  delete Component.options._Ctor
}
